import { PaginationResponse, backendInstance } from './base'

export const BASE_URL = 'geo'

export type AddressAutocompleteItem = {
  id: number
  address: string
  addressEn?: string
  country: string
  score: number
  latitude: number
  longitude: number
  docCount: number
}

export type AddressStorageType = {
  address: string
  latitude: number
  longitude: number
}

export type AddressAutocompleteRequest = {
  page: number
  cityPart: string | null
  addressPart: string | null
  pageSize?: number
  abortSignal?: AbortSignal
}

export type AddressAutocompleteResponse = PaginationResponse<
  AddressAutocompleteItem[]
>

export type AutocompleteAddressesResultType = AddressAutocompleteResponse

export const getAddressesForAutocompleteCall = async ({
  page,
  addressPart,
  cityPart,
  pageSize = 40,
  abortSignal
}: AddressAutocompleteRequest): Promise<AutocompleteAddressesResultType> => {
  try {
    const response = await backendInstance.get(`${BASE_URL}/hint`, {
      params: {
        pageNumber: page,
        addressPart: addressPart,
        cityPart: cityPart,
        pageSize: pageSize
      },
      signal: abortSignal
    })
    const jsonData = response.data
    return jsonData
  } catch (error: unknown) {
    return await Promise.reject(error)
  }
}
